<template>
  <div class="crear-cumplimiento">
    <h3 class="text-center mb-4">Crear Nuevo Cumplimiento o Etiqueta</h3>

    <!-- Leyenda Explicativa Dinámica -->
    <div class="alert alert-info mb-4">
      <p><strong>¿Qué son los tipos de Cumplimiento/Etiqueta?</strong></p>
      <ul>
        <li v-if="nuevoCumplimiento.tipo === 'deber'">
          <strong>Deber:</strong> Un requerimiento obligatorio que debe cumplirse dentro del grupo seleccionado.
        </li>
        <li v-if="nuevoCumplimiento.tipo === 'normativa'">
          <strong>Normativa:</strong> Reglas o regulaciones que rigen la gestión del grupo.
        </li>
        <li v-else>
          Seleccione un tipo de cumplimiento para ver su descripción.
        </li>
      </ul>
    </div>

    <!-- Selección de Grupo -->
    <div class="mb-3">
      <label for="grupoSeleccionado" class="form-label">Seleccionar Grupo</label>
      <select v-model="selectedGrupo" class="form-select" id="grupoSeleccionado" required :disabled="!!grupo_id">
        <option value="" disabled>Seleccione un grupo...</option>
        <option v-for="grupo in grupos" :key="grupo.id" :value="grupo.id">
          {{ grupo.nombre }}
        </option>
      </select>
    </div>

    <!-- Formulario para Cumplimiento -->
    <div class="row mb-3">
      <div class="col-md-6">
        <label for="nombreCumplimiento" class="form-label">Nombre del Cumplimiento/Etiqueta</label>
        <input type="text" class="form-control" id="nombreCumplimiento" v-model="nuevoCumplimiento.nombre" required />
      </div>
      <div class="col-md-6">
        <label for="descripcionCumplimiento" class="form-label">Descripción</label>
        <input type="text" class="form-control" id="descripcionCumplimiento" v-model="nuevoCumplimiento.descripcion" required />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-6">
        <label for="tipoCumplimiento" class="form-label">Tipo</label>
        <select id="tipoCumplimiento" class="form-select" v-model="nuevoCumplimiento.tipo" required>
          <option value="deber">Deber</option>
          <option value="normativa">Normativa</option>
        </select>
      </div>
      <div class="col-md-6">
        <label for="estadoCumplimiento" class="form-label">Estado</label>
        <select id="estadoCumplimiento" class="form-select" v-model="nuevoCumplimiento.estado" required>
          <option value="activo">Activo</option>
          <option value="inactivo">Inactivo</option>
        </select>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-6">
        <label for="precedencia" class="form-label">Precedencia</label>
        <input type="number" class="form-control" id="precedencia" v-model="nuevoCumplimiento.precedencia" required />
      </div>
      <div class="col-md-6">
        <label for="fechaInicio" class="form-label">Fecha de Inicio</label>
        <input type="date" class="form-control" id="fechaInicio" v-model="nuevoCumplimiento.fecha_inicio" required />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-6">
        <label for="fechaFin" class="form-label">Fecha de Fin</label>
        <input type="date" class="form-control" id="fechaFin" v-model="nuevoCumplimiento.fecha_fin" required />
      </div>
      <div class="col-md-6 d-flex align-items-center">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" id="esObligatoria" v-model="nuevoCumplimiento.es_obligatoria" />
          <label for="esObligatoria" class="form-check-label">¿Es Obligatoria?</label>
        </div>
      </div>
    </div>

    <!-- Botón para guardar cumplimiento -->
    <button class="btn btn-primary w-100" @click="crearCumplimiento">Guardar</button>


    <!-- Mensaje de estado -->
    <p v-if="mensaje" class="mt-3 alert alert-success">{{ mensaje }}</p>
  </div>
</template>

<script>
import axios from '@/axios';

export default {
  data() {
    return {
      grupos: [],
      selectedGrupo: null,
      clubActual: null,
      nuevoCumplimiento: {
        nombre: '',
        descripcion: '',
        tipo: 'deber',
        estado: 'activo',
        precedencia: (this.maxPrecedencia ? this.maxPrecedencia + 1 : 1),
        fecha_inicio: new Date().toISOString().split('T')[0],
        fecha_fin: '',
        es_obligatoria: false,
      },
      mensaje: '',
    };
  },
  props: {
    grupo_id: {
      type: Number,
      required: false,
    },
    maxPrecedencia: {
      type: Number,
      required: true,
      
    },
  },
  mounted() {
    this.cargarGrupos();
  },
  methods: {
    async cargarGrupos() {
      try {
        const response = await axios.get('/api/cumplimiento/grupos',{params: {club_id: this.clubActual.id}});
        this.grupos = response.data;

        if (this.grupo_id) {
          this.selectedGrupo = this.grupo_id;
        }
      } catch (error) {
        console.error('Error al cargar grupos:', error);
      }
    },
    async crearCumplimiento() {
      if (!this.selectedGrupo) {
        alert('Por favor, seleccione un grupo.');
        return;
      }

      try {
        const nuevoCumplimiento = {
          ...this.nuevoCumplimiento,
          grupo_id: this.selectedGrupo,
        };
        alert('Cumplimiento creado correctamente');
        this.$emit('cumplimientoCreado', nuevoCumplimiento);
        this.mensaje = 'Cumplimiento o etiqueta creada exitosamente.';
        this.resetFormulario();
      } catch (error) {
        console.error('Error al crear el cumplimiento:', error);
        this.mensaje = 'Error al crear el cumplimiento.';
      }
    },
    cancelar() {
      this.resetFormulario();
        this.$emit('cerrar', null);
    },
    resetFormulario() {
      this.nuevoCumplimiento = {
        nombre: '',
        descripcion: '',
        tipo: 'deber',
        estado: 'activo',
        precedencia: (this.maxPrecedencia ? this.maxPrecedencia + 1 : 1),
        fecha_inicio: new Date().toISOString().split('T')[0],
        fecha_fin: '',
        es_obligatoria: false,
      };
    },
  },
  created() {
    this.clubActual = this.$store.getters.getClubActual;
  },
};
</script>

<style scoped>
.crear-cumplimiento {
  background-color: #f8f9fa;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.alert-info {
  font-size: 0.9rem;
  margin-bottom: 1rem;
}

.form-label {
  font-weight: bold;
}

.btn-primary {
  width: 100%;
}

.alert {
  margin-top: 1rem;
}
</style>
